import React from "react";
import { useApp } from "../../contexts";

export const ItemAffiliate = ({ value, ...props }) => {
  const { T, language } = useApp();
  const { btnAction, btnActionTitle, className, title, description } = props; 

  return (
    <div className={`w-full ${className}`}>
        <div
            className={`text-white font-semibold text-[24px]/[28px] ${language === 'pt' ? 'xl:text-[32px]/[45px]' : 'xl:text-[37px]/[50px]'} title uppercase w-[200px] lg:w-[300px] md:w-[250px] drop-shadow`}
            dangerouslySetInnerHTML={{
            __html: T(title),
            }}
        ></div>
        <div className={`w-[170px] md:w-[250px] lg:w-[200px] xl:w-[250px] 3xl:w-[300px] text-white font-semibold ${(language === 'pt' || language === 'es') ? 'text-[12px]/[18px] sm:text-[14px]/[20px]' : 'text-[14px]/[20px]'} description drop-shadow`}>
            <div dangerouslySetInnerHTML={{
            __html: T(description),
            }}></div>
        </div>
        <div className={`flex justify-start items-center gap-4 mt-2 lg:mt-[40px]`}>
            <button className="earn-big-btn" onClick={btnAction}>
                {btnActionTitle ?? T('My Affiliate')}
            </button>
        </div> 
    </div>
  );
};
